<template>
  <div class="panel-chat-footer">
    <button id="btnModalChat" class="btn-chat" @click="setShowModalChat()">
      <!-- v-bind:style="[{ backgroundColor: primaryColor }]" -->
      <!-- <font-awesome-icon icon="comments" class="icon-chat" /> -->

      <svg
        width="64"
        height="64"
        viewBox="0 0 64 64"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect width="64" height="64" rx="32" fill="black"></rect>
        <path d="M25.25 31.625H28.25V29.375H25.25V31.625Z" fill="white"></path>
        <path d="M30.5 31.625H33.5V29.375H30.5V31.625Z" fill="white"></path>
        <path d="M38.75 31.625H35.75V29.375H38.75V31.625Z" fill="white"></path>
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M44 21.5V44L39.5 39.5H20V21.5H44ZM40.432 37.25H22.25V23.75H41.75V38.568L40.432 37.25Z"
          fill="white"
        ></path>
      </svg>
      <span class="text-chat">{{ title }}</span>
    </button>
  </div>
</template>

<script>
export default {
  name: "ChatModal",
  props: {
    config: {
      required: true,
      type: Object,
    },
    isShowModalChat: {
      required: true,
      type: Boolean,
    },
    isDisplayModalChat: {
      required: true,
      type: Boolean,
    },
  },
  data() {
    return {
      title: this.config.titleButton,
      primaryColor: this.config.color,
      showChat: this.isShowModalChat,
      displayChat: this.isDisplayModalChat,
    };
  },
  methods: {
    setShowModalChat() {
      if (this.isDisplayModalChat) {
        this.setDisplayModalChat();
      } else {
        this.setDisplayModalChat();
        this.showChat = true;
        this.$emit("setShowModal", true);
      }
    },
    setDisplayModalChat() {
      this.displayChat = true;
      this.$emit("setDisplayModal", true);
    },
  },
};
</script>

<style lang="scss" scoped>
* {
  font-family: inherit;
}
.panel-chat-footer {
  position: fixed;
  bottom: 1rem;
  right: 1rem;
  z-index: 100;
}
.btn-chat {
  // height: 40px;
  // width: 100px;
  padding: 0;
  border: 0px;
  display: flex;
  justify-content: center;
  align-items: center;
  // border-radius: 50px;
  background-color: transparent;
}

.panel-chat-footer {
  background-color: transparent;
}
.btn-chat:hover {
  cursor: pointer;
}
.icon-chat {
  font-size: 20px;
  color: white;
}
.text-chat {
  font-size: 16px;
  margin-left: 5px;
  color: white;
  font-family: inherit;
}
button:focus {
  box-shadow: 0 0 0 0.1rem rgba(89, 90, 92, 0.25);
  outline: none;
}
</style>
